module.exports = __webpack_public_path__ + "static/media/AntidoteToChurn.fc55446f.png";